/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDailyTripHistoryResponse } from '../models/ApiResponseDailyTripHistoryResponse';
import type { ApiResponseEvStatsFor30Days } from '../models/ApiResponseEvStatsFor30Days';
import type { ApiResponseEvStatsOfLastDrive } from '../models/ApiResponseEvStatsOfLastDrive';
import type { ApiResponseFilteredTripHistoryResponse } from '../models/ApiResponseFilteredTripHistoryResponse';
import type { ApiResponseMonthlyDrivingInfoResponse } from '../models/ApiResponseMonthlyDrivingInfoResponse';
import type { ApiResponseMonthlyStatsResponse } from '../models/ApiResponseMonthlyStatsResponse';
import type { ApiResponseOdometerResponse } from '../models/ApiResponseOdometerResponse';
import type { ApiResponseRecentTripDaysResponse } from '../models/ApiResponseRecentTripDaysResponse';
import type { ApiResponseTripDaysResponse } from '../models/ApiResponseTripDaysResponse';
import type { ApiResponseTripHistory } from '../models/ApiResponseTripHistory';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DrivingHistoryService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 주행 이력 필터 조회
   * 기간별/태그별 필터링 조건으로 트립 리스트를 조회합니다. 페이징을 지원합니다 (page, size 파라미터).
   * @returns ApiResponseFilteredTripHistoryResponse OK
   * @throws ApiError
   */
  public retrieveFilteredTripHistory({
    vin,
    clientTimezone,
    startDate = '20260908',
    endDate = '20260908',
    orderBy = 'DESC',
    tagNames,
    tagIds,
    driverUserIds,
    page = 1,
    size = 20,
    sort,
  }: {
    vin: string,
    clientTimezone?: string,
    startDate?: string,
    endDate?: string,
    orderBy?: 'ASC' | 'DESC',
    /**
     * 태그 이름 목록 (쉼표 구분, OR 조건)
     */
    tagNames?: Array<string>,
    /**
     * 태그 식별자 목록 (쉼표 구분, OR 조건)
     */
    tagIds?: Array<string>,
    driverUserIds?: Array<string>,
    /**
     * One-based page index (1..N)
     */
    page?: number,
    /**
     * The size of the page to be returned
     */
    size?: number,
    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    sort?: Array<string>,
  }): CancelablePromise<ApiResponseFilteredTripHistoryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/filtered',
      headers: {
        'Client-Timezone': clientTimezone,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
        'orderBy': orderBy,
        'tagNames': tagNames,
        'tagIds': tagIds,
        'driverUserIds': driverUserIds,
        'page': page,
        'size': size,
        'sort': sort,
      },
    });
  }
  /**
   * 트립 상세 조회
   * 특정 트립의 상세 정보를 조회합니다.
   * @returns ApiResponseTripHistory OK
   * @throws ApiError
   */
  public retrieveTripDetail({
    vin,
    tripId,
    clientTimezone,
  }: {
    vin: string,
    tripId: string,
    clientTimezone?: string,
  }): CancelablePromise<ApiResponseTripHistory> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/detail',
      headers: {
        'Client-Timezone': clientTimezone,
      },
      query: {
        'vin': vin,
        'tripId': tripId,
      },
    });
  }
  /**
   * 최근 주행 날짜 조회
   * 주행 데이터가 있는 가장 최근 월의 날짜별 주행 횟수와 가장 최근 주행일을 반환합니다. CCS 동의일 이전 날짜는 제외됩니다.
   * @returns ApiResponseRecentTripDaysResponse OK
   * @throws ApiError
   */
  public retrieveRecentTripDays1({
    vin,
    clientTimezone,
  }: {
    vin: string,
    clientTimezone?: string,
  }): CancelablePromise<ApiResponseRecentTripDaysResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/days/recent',
      headers: {
        'Client-Timezone': clientTimezone,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 월별 주행 날짜 조회
   * 차량의 월별 주행 날짜를 조회합니다.
   * @returns ApiResponseTripDaysResponse OK
   * @throws ApiError
   */
  public retrieveTripDays1({
    vin,
    clientTimezone,
    month = '202609',
  }: {
    vin: string,
    clientTimezone?: string,
    month?: string,
  }): CancelablePromise<ApiResponseTripDaysResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/days',
      headers: {
        'Client-Timezone': clientTimezone,
      },
      query: {
        'vin': vin,
        'month': month,
      },
    });
  }
  /**
   * 주행 이력 조회
   * 특정 날짜의 주행 이력을 조회합니다. 태그 이름 목록으로 필터링할 수 있습니다 (OR 조건). 페이징을 지원합니다 (page, size 파라미터).
   * @returns ApiResponseDailyTripHistoryResponse OK
   * @throws ApiError
   */
  public retrieveDailyTripHistory({
    vin,
    clientTimezone,
    date = '20260908',
    orderBy = 'DESC',
    tagNames,
    tagIds,
    driverUserIds,
    paging = false,
    page = 1,
    size = 20,
    sort,
  }: {
    vin: string,
    clientTimezone?: string,
    date?: string,
    orderBy?: 'ASC' | 'DESC',
    /**
     * 태그 이름 목록 (쉼표 구분, OR 조건)
     */
    tagNames?: Array<string>,
    /**
     * 태그 식별자 목록 (쉼표 구분, OR 조건)
     */
    tagIds?: Array<string>,
    /**
     * 운전자 식별자 목록 (쉼표 구분, OR 조건)
     */
    driverUserIds?: Array<string>,
    paging?: boolean,
    /**
     * One-based page index (1..N)
     */
    page?: number,
    /**
     * The size of the page to be returned
     */
    size?: number,
    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    sort?: Array<string>,
  }): CancelablePromise<ApiResponseDailyTripHistoryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip',
      headers: {
        'Client-Timezone': clientTimezone,
      },
      query: {
        'vin': vin,
        'date': date,
        'orderBy': orderBy,
        'tagNames': tagNames,
        'tagIds': tagIds,
        'driverUserIds': driverUserIds,
        'paging': paging,
        'page': page,
        'size': size,
        'sort': sort,
      },
    });
  }
  /**
   * 트립 삭제
   * 트립을 삭제합니다. 삭제된 트립은 아카이브 테이블로 이관됩니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteTrip({
    vin,
    tripId,
  }: {
    vin: string,
    tripId: number,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/drive-history/trip',
      query: {
        'vin': vin,
        'tripId': tripId,
      },
    });
  }
  /**
   * 누적 주행 거리 조회
   * 차량의 누적 주행 거리를 조회합니다
   * @returns ApiResponseOdometerResponse OK
   * @throws ApiError
   */
  public retrieveOdometer({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseOdometerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/odometer',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 월별 주행 통계 조회
   * 차량의 월별 주행 통계를 조회합니다(최대 3개월)
   * @returns ApiResponseMonthlyStatsResponse OK
   * @throws ApiError
   */
  public retrieveMonthlyStats1({
    vin,
    clientTimezone,
  }: {
    vin: string,
    clientTimezone?: string,
  }): CancelablePromise<ApiResponseMonthlyStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/monthly-stats',
      headers: {
        'Client-Timezone': clientTimezone,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * EV Statistics Of Last Drive
   * EV Statistics Of Last Drive
   * @returns ApiResponseEvStatsOfLastDrive OK
   * @throws ApiError
   */
  public retrieveEvStatsOfLastDrive({
    vin,
    clientTimezone,
  }: {
    vin: string,
    clientTimezone?: string,
  }): CancelablePromise<ApiResponseEvStatsOfLastDrive> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats/recent',
      headers: {
        'Client-Timezone': clientTimezone,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * EV Statistics For 30 Days
   * EV Statistics For 30 Days
   * @returns ApiResponseEvStatsFor30Days OK
   * @throws ApiError
   */
  public retrieveEvStatsFor30Days({
    vin,
    clientTimezone,
  }: {
    vin: string,
    clientTimezone?: string,
  }): CancelablePromise<ApiResponseEvStatsFor30Days> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats',
      headers: {
        'Client-Timezone': clientTimezone,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 월별 주행 정보 조회
   * 차량의 월별 주행 정보를 조회합니다.
   * @returns ApiResponseMonthlyDrivingInfoResponse OK
   * @throws ApiError
   */
  public retrieveDrivingInfo({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseMonthlyDrivingInfoResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/car/trip/driving-info',
      query: {
        'vin': vin,
      },
    });
  }
}
